import type * as React from 'react';
import { del } from '@Domain/Api';
import aiModelDeleted, {
	type AiModelDeletedAction,
} from '@Application/Ai/AiConfiguration/Models/Actions/aiModelDeleted';
import aiModelDeletionFailed, {
	type AiModelDeletionFailedAction,
} from '@Application/Ai/AiConfiguration/Models/Actions/aiModelDeletionFailed';
import type DeleteAiModel from '@Application/Ai/AiConfiguration/Models/Commands/DeleteAiModel';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = AiModelDeletedAction | AiModelDeletionFailedAction;

export default (command: DeleteAiModel) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(
				`${parameters.api.host}/api/accounts/${command.accountId}/ai-models/${command.modelId}`,
			);

			const action = aiModelDeleted({ modelId: command.modelId }, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiModelDeletionFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
